import React from 'react'
import { Link } from 'react-router-dom'
const Notfound = () => {
    return (
        <div>
        <div id="content" class="pmd-content errorpage d-flex justify-content-center align-items-center">
	<div class="text-center error-page">
		<img src="/themes/images/404.png" alt="404" class="mb-4 img-fluid"/>
		<h1>Oops! Page not found</h1>
		<p class="mb-4">Sorry, but the page you are looking for is not found.
			Please make sure you have typed the right URL.</p>
		<Link class=" btn-primary btn-lg pmd-btn-raised pmd-ripple-effect" title="Back to home" to="/admin">Back to home</Link>
	</div>
</div>
        </div>
    )
}

export default Notfound
